<template>
  <div class="index">
    <topnav isImg />
    <div class="main">
      <van-image
        lazy-load
        width="100%"
        height="3.6rem"
        :src="require('../../assets/images/banner.png')"
      />
      <div class="list-box">
        <ul>
          <li
            class="list-item"
            v-for="(item, index) in list"
            :key="index"
            @click="go(item.name,index)"
          >
            <van-image lazy-load width="3rem" height="1.4rem" :src="item.imgSrc" />
            <p>{{ item.title }}</p>
          </li>
        </ul>
      </div>
    </div>
    <tabbar isOneActive />
  </div>
</template>

<script>
import Topnav from "@/components/Topnav";
import Tabbar from "@/components/Tabbar";
import { checktime } from "@/api/index.js";
import { Dialog } from "vant";
import axios from "axios";

export default {
  name: "Index",
  components: {
    Topnav,
    Tabbar,
    Dialog
  },
  data() {
    return {
      list: [
        {
          title: "武汉青创训练营",
          name: "Camp",
          imgSrc: require("../../assets/images/list-4.png")
        },
        {
          title: "“追梦计划”创业大赛",
          name: "Declare",
          imgSrc: require("../../assets/images/list-1.png")
        },
        {
          title: "创业链·青年圈”活动",
          name: "",
          imgSrc: require("../../assets/images/list-2.png")
        },
        {
          title: "武汉青年创业（示范）基地",
          name: "",
          imgSrc: require("../../assets/images/list-3.png")
        }
      ]
    };
  },
  methods: {
    go(name, index) {
      if (name) {
        switch (index) {
          case 0:
            checktime()
              .then(res => {
                if (res.data.flag == 2) {
                  Dialog.alert({
                    title: "提示",
                    message: "报名时间已截止"
                  }).then(() => {
                    // on close
                  });
                  return false;
                }
                this.$router.push({
                  name: name
                });
              })
              .catch(err => {
                console.log(err);
              });
            break;
          case 1:
            axios({
              method: "get",
              url: "http://whqncy.com/api/index/checktime",
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
              .then(res => {
                if (res.data.data.flag == 2) {
                  Dialog.alert({
                    title: "提示",
                    message: "报名时间已截止"
                  }).then(() => {
                    // on close
                  });
                  return false;
                }
                this.$router.push({
                  name: name
                });
              })
              .catch(err => {
                console.log(err);
              });
            break;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {
  .main {
    padding-top: var(--window-top);
    padding-bottom: var(--window-bottom);
    .list-box {
      padding: 0.2rem;
      .list-item {
        margin-bottom: 0.4rem;
        display: flex;
        align-items: center;
        p {
          font-size: 0.28rem;
          font-weight: bold;
          color: #535353;
          margin-left: 0.3rem;
        }
      }
    }
  }
}
</style>